import {getSnapshot, types} from "mobx-state-tree";

const ImageFormat = types.model({
  label: types.string,
  value: types.string,
});

export const QrDownloadState = types.model('QrDownloadState', {
  options: types.optional(types.array(ImageFormat), [
        { label: "PNG", value: "png" },
        { label: "JPG", value: "jpg" },
        { label: "BMP", value: "bmp" },
        { label: "EPS", value: "eps" },
        { label: "GIF", value: "gif" },
        { label: "PDF", value: "pdf" },
        { label: "SVG", value: "svg" },
        // { label: "TIFF", value: "tiff" }
      ]),
  downloadImageFormat: types.optional(ImageFormat, () => ({ label: "PNG", value: "png" })),
  defaultImageFormat: types.optional(ImageFormat, () => ({ label: "PNG", value: "png" })),
  downloadImage: types.optional(types.string, ""),
})
.actions((self) => ({
    handleDownloadImageFormat(imageFormat){
      // const imageFormat = self.determineImageFormat(colorMode, transparentBackgroun)
      const selectedImageFormat = ImageFormat.create({label: imageFormat.label, value: imageFormat.value})
      self.downloadImageFormat = selectedImageFormat
    },
    handleOptions(qrConfig, v1ImageConfig = {}) {
      if(!qrConfig || qrConfig == {}) {
        qrConfig = {
          colorMode: 'rgb',
          transparentBackground: false,
          isDefaultDesigner: true,
          isCMYK: false,
          backgroundImage: null,
          logo: null
        }
      }
      self.options = []
      let newOptions = [
        { label: "PNG", value: "png" },
        { label: "JPG", value: "jpg" },
        { label: "BMP", value: "bmp" },
        { label: "EPS", value: "eps" },
        { label: "GIF", value: "gif" },
        { label: "PDF", value: "pdf" },
        { label: "SVG", value: "svg" },
        { label: "AI", value: "ai" }
        // { label: "TIFF", value: "tiff" },
      ]; // Create a new array
      const colorMode = qrConfig.colorMode;
      const transparentBackground = qrConfig.transparentBackground;
      // let isV2Designer = true;
      // 01/12/2026 we don't use isDefaultDesigner, if config fits tec-it, then using tec-it or using v2 image service
      // if(qrConfig.hasOwnProperty('isDefaultDesigner')){
      //   isDefaultDesigner = qrConfig.isDefaultDesigner;

      // }
      // if(validForBWRImageConfig(qrConfig, v1ImageConfig) || qrConfig.barcodeFormat === barcodeFormatConstants.DATA_MATRIX){
      //   isV2Designer = false;
      // }

      if (colorMode === "cmyk" || qrConfig.isCMYK) {
        newOptions = newOptions.filter(option => (option.value !== 'bmp' && option.value !== 'svg' && option.value !== 'png' && option.value !== 'gif'));
      }

      if (transparentBackground) {
          newOptions = newOptions.filter(option => option.value !== 'jpg');
      } else {
          // const jpgOption = { label: "JPG", value: "jpg" };
          // if (!newOptions.some(option => option.value === jpgOption.value)) {
          //     newOptions = [jpgOption, ...newOptions];
          // }
      }

      // // V2 support AI format, we remove below
      // if it is v1 config, add AI option
      // if (isV2Designer) {
      //   newOptions = newOptions.filter(option => option.value !== 'ai');
      // } else {
      //     const aiOption = { label: "AI", value: "ai" };
      //     if (!newOptions.some(option => option.value === aiOption.value)) {
      //         newOptions = [...newOptions, aiOption];
      //     }
      // }

      self.options = newOptions;
      const selectedImageFormat = ImageFormat.create({label: newOptions[0].label, value: newOptions[0].value})
      self.downloadImageFormat = selectedImageFormat;
      self.defaultImageFormat = selectedImageFormat;
    },
    handleDefaultImageFormat(colorMode, transparentBackground){
      const imageFormat = self.determineImageFormat(colorMode, transparentBackground)
      self.defaultImageFormat = imageFormat
      // self.downloadImageFormat = imageFormat
    },
    determineImageFormat(colorMode, transparentBackground) {
      if(colorMode === 'cmyk' && !transparentBackground){
        return { label: "EPS", value: "eps" }
      } else if(colorMode === 'cmyk' && transparentBackground){
        return { label: "EPS", value: "eps" }
      } else {
        return { label: "PNG", value: "png" }
      }
    },
    setImageFormat(imageFormat) {
      // only use for batch download details page
      const option = { label: imageFormat.toUpperCase(), value: imageFormat };
      self.downloadImageFormat = option
    }


  }))


//
